// WelcomeScreen.jsx - Team selection interface with Apple-like design
import React from 'react';

const WelcomeScreen = ({ clubName, clubLogo, date, teams, onTeamSelect }) => {
  const isMobile = window.innerWidth <= 768;
  
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-AU', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#243665',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: '0',
      paddingTop: '0',
      gap: '0'
    }}>
      {/* Pitchallo Logo */}
      <img 
        src="/Pitchallo.svg" 
        alt="Pitchallo"
        style={{
          height: isMobile ? '180px' : '480px',
          width: 'auto'
        }}
      />

      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        maxWidth: '440px',
        width: '100%',
        overflow: 'hidden'
      }}>
        {/* Header Section */}
        <div style={{
          padding: '40px 32px 32px',
          textAlign: 'center',
          borderBottom: '1px solid #f3f4f6'
        }}>
          {clubLogo && (
            <img 
              src={clubLogo} 
              alt={clubName}
              style={{
                width: '80px',
                height: '80px',
                objectFit: 'contain',
                margin: '0 auto 24px',
                display: 'block'
              }}
            />
          )}
          
          <h1 style={{
            fontSize: '28px',
            fontWeight: '700',
            color: '#111827',
            margin: '0 0 8px 0',
            lineHeight: '1.2'
          }}>
            Welcome to {clubName}
          </h1>
          
          <p style={{
            fontSize: '15px',
            color: '#6b7280',
            margin: '0 0 4px 0'
          }}>
            {formatDate(date)}
          </p>
        </div>

        {/* Team Selection Section */}
        <div style={{
          padding: '24px 32px'
        }}>
          <p style={{
            fontSize: '17px',
            fontWeight: '600',
            color: '#374151',
            margin: '0 0 16px 0'
          }}>
            Which team are you looking for?
          </p>

          {/* Team Buttons */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}>
            {teams.map((team, index) => (
              <button
                key={index}
                onClick={() => onTeamSelect(team)}
                style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  border: '1.5px solid #e5e7eb',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#1f2937',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  textAlign: 'left',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f9fafb';
                  e.currentTarget.style.borderColor = '#3b82f6';
                  e.currentTarget.style.transform = 'translateX(4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'white';
                  e.currentTarget.style.borderColor = '#e5e7eb';
                  e.currentTarget.style.transform = 'translateX(0)';
                }}
              >
                <span style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px'
                }}>
                  <span style={{
                    fontSize: '20px'
                  }}>⚽</span>
                  {team}
                </span>
                <span style={{
                  color: '#9ca3af',
                  fontSize: '18px'
                }}>›</span>
              </button>
            ))}
          </div>

          {/* View All Teams Button */}
          <button
            onClick={() => onTeamSelect('all')}
            style={{
              marginTop: '16px',
              width: '100%',
              padding: '16px 20px',
              backgroundColor: '#f9fafb',
              border: '1.5px solid #e5e7eb',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: '500',
              color: '#6b7280',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f3f4f6';
              e.currentTarget.style.color = '#374151';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#f9fafb';
              e.currentTarget.style.color = '#6b7280';
            }}
          >
            <span style={{ fontSize: '18px' }}>📅</span>
            View All Teams
          </button>
        </div>

        {/* Footer Note */}
        <div style={{
          padding: '16px 32px 24px',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '13px',
            color: '#9ca3af',
            margin: 0
          }}>
            Select a team to see their schedule for today
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
